module.exports = __webpack_public_path__ + "img/icon-payment-nfc-blue.76cde9a8.png";